import { render, staticRenderFns } from "./loyaltyPointsUpdate.vue?vue&type=template&id=c2cd52d8&"
import script from "./loyaltyPointsUpdate.vue?vue&type=script&lang=js&"
export * from "./loyaltyPointsUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports